export interface ISystemInfo {
    systemTime: Date;
    systemType: string;
    systemVersion: string;
    cloudConnectorVersion: string;
}

export class SystemInfo implements ISystemInfo {
    systemTime: Date;
    systemType: string;
    systemVersion: string;
    cloudConnectorVersion: string;

    constructor(systemTime: Date,
        systemType: string,
        systemVersion: string,
        cloudConnectorVersion: string) {
        this.systemTime = systemTime;
        this.systemType = systemType;
        this.systemVersion = systemVersion;
        this.cloudConnectorVersion = cloudConnectorVersion;
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemHealthRetriever/system-info.ts
 **/